import { inboundShipmentIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

/** Confirms all receiving bins are physically empty and reconciles aggregate balances to zero. */
export const closeReceivingShipment = {
  name: "closeReceivingShipment" as const,
  input: z.object({ inboundShipmentId: inboundShipmentIdFormat.schema }),
  output: z.object({
    inboundShipmentId: inboundShipmentIdFormat.schema,
    closedAt: z.string(),
    outcome: z.enum(["closed", "already_closed"]),
    binsClosed: z.number(),
    binsAlreadyClosed: z.number(),
    aggregateUnitsAdjusted: z.number(),
    affectedProductCount: z.number(),
    adjustmentReferenceId: z.string().nullable(),
  }),
};
